import { RolodexFilePath } from 'types'

import {
  cantileverDocumentEntryId,
  cantileverDocumentPageIdForPage,
} from './cantileverHostIds'

type ImageVariant = 'thumbnail' | 'hiRes'

const IMAGE_PATH_BY_VARIANT: Record<ImageVariant, string> = {
  thumbnail: 'thumbnail.png',
  hiRes: '6400px.png',
}

export function filenameStem(filename: string): string {
  const dotIndex = filename.lastIndexOf('.')
  return dotIndex > 0 ? filename.slice(0, dotIndex) : filename
}

export function pdfRenditionFilename(filename: string): string {
  return `${filenameStem(filename)}.pdf`
}

export function resolvePdfFileRef(
  cantileverDocumentEntryId: string,
  filename: string
): RolodexFilePath {
  return {
    entry_id: cantileverDocumentEntryId,
    path: pdfRenditionFilename(filename),
  }
}

export function resolveOriginalFileRef(
  cantileverDocumentEntryId: string,
  filename: string
): RolodexFilePath {
  return {
    entry_id: cantileverDocumentEntryId,
    path: filename,
  }
}

export function resolvePageImageFileRef(
  cantileverDocumentPageId: string,
  variant: ImageVariant
): RolodexFilePath {
  return {
    entry_id: cantileverDocumentPageId,
    path: IMAGE_PATH_BY_VARIANT[variant],
  }
}

export function resolveDerivedPageImageFileRef(args: {
  siteId: string | undefined
  bqDocumentId: string | undefined
  pageNumber: number
  variant: ImageVariant
}): RolodexFilePath | undefined {
  const { siteId, bqDocumentId, pageNumber, variant } = args
  if (!siteId || !bqDocumentId) return undefined
  return resolvePageImageFileRef(
    cantileverDocumentPageIdForPage(siteId, bqDocumentId, pageNumber),
    variant
  )
}

export function resolveDerivedPdfFileRef(args: {
  siteId: string | undefined
  bqDocumentId: string | undefined
  filename: string | undefined
  cantileverDocumentEntryId?: string
}): RolodexFilePath | undefined {
  const {
    siteId,
    bqDocumentId,
    filename,
    cantileverDocumentEntryId: knownCantileverDocumentEntryId,
  } = args
  if (!filename) return undefined
  if (knownCantileverDocumentEntryId) {
    return resolvePdfFileRef(knownCantileverDocumentEntryId, filename)
  }
  if (siteId && bqDocumentId) {
    return resolvePdfFileRef(
      cantileverDocumentEntryId(siteId, bqDocumentId),
      filename
    )
  }
  return undefined
}

export function resolveDerivedOriginalFileRef(args: {
  siteId: string | undefined
  bqDocumentId: string | undefined
  filename: string | undefined
  cantileverDocumentEntryId?: string
}): RolodexFilePath | undefined {
  const {
    siteId,
    bqDocumentId,
    filename,
    cantileverDocumentEntryId: knownCantileverDocumentEntryId,
  } = args
  if (!filename) return undefined
  if (knownCantileverDocumentEntryId) {
    return resolveOriginalFileRef(knownCantileverDocumentEntryId, filename)
  }
  if (siteId && bqDocumentId) {
    return resolveOriginalFileRef(
      cantileverDocumentEntryId(siteId, bqDocumentId),
      filename
    )
  }
  return undefined
}
